<template>
<div id="cartaporte">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="mdi-qrcode" :title="(editando?'Editar':'Nuevo') + ' CFDI'" class="elevation-1 ">

                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <div style="width:95%; position:absolute; top:0px;">
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-alert color="green" outlined dense type="info"><span style="font-size:10px;">Si no se específica la Serie y Folio el sistema asignara en automático el de la configuración.</span></v-alert>

                                        </v-col>

                                    </v-row>
                                    <v-row style="width:100%; position:absolute; top:45px; left:10px;">
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-if="series.length==0" v-model="model.serie" label="Serie"></v-text-field>
                                            <v-autocomplete v-if="series.length>0" v-model="model.serie" label="Serie" :items="series" clearable item-text="text" item-value="id">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-model="model.folio" label="Folio"></v-text-field>
                                        </v-col>
                                    </v-row>

                                </div>

                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <h5><b>Emisor</b> </h5><span class="title">{{model.emisor.rfc}} - {{model.emisor.razon_social}}</span>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="model.FechaPago" label="Fecha" readonly v-bind="attrs" v-on="on" @click:clear="model.FechaPago = null"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.FechaPago" no-title locale="MX" @change="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-if="model.TipoDeComprobante=='I' || model.concarta==false" v-model="model.receptor" label="Receptor" return-object :items="receptores" :hide-no-data="true" item-text="razon_social" item-value="uuid" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.rfc}} - {{ item.razon_social}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.rfc}} - {{ item.razon_social}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>

                                </v-row>
                                <v-row>

                                    <v-col sm="4" md="4" lg="4">

                                        <v-autocomplete v-model="model.TipoDeComprobante" @change="cargarProductos(); model.lista_productos = [];" label="Tipo de Comprobante" :items="TiposDeComprobante" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]" />

                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-switch v-model="model.concarta" label="Con Carta Porte" @change="cargarProductos(); model.lista_productos = [];"></v-switch>
                                    </v-col>
                                    <v-col v-if="model.TipoDeComprobante=='I'" sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.UsoCFDI" label="Uso CFDI" :items="UsosCFDI" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="model.LugarExpedicion" label="CP Lugar Expedición" :rules="[rules.required]"></v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row v-if="model.TipoDeComprobante == 'I'">

                                    <v-col sm="3" md="3" lg="3">
                                        <v-autocomplete v-model="model.Moneda" label="Moneda" :items="Monedas" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]" />
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.TipoCambio" label="Tipo de Cambio" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-autocomplete v-if="model.TipoDeComprobante == 'I'" @change="model.MetodoPago=='PPD'?model.FormaPago='99':''" v-model="model.MetodoPago" label="Metodo Pago" :items="MetodosPago" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>

                                    </v-col>

                                    <v-col sm="3" md="3" lg="3">
                                        <v-autocomplete v-if="model.TipoDeComprobante == 'I'" v-model="model.FormaPago" :disabled="model.MetodoPago=='PPD'" label="Forma Pago" :items="FormasPago" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-card id="carta_porte" v-if="model.concarta== true" elevation="3" class="pa-5">
                                    <div class="text-overline mb-4">
                                        COMPLEMENTO CARTA PORTE
                                    </div>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-text-field v-model="model.IdCCP" label="UUID Carta Porte" :rules="[rules.required]" disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">

                                            <!-- <v-switch v-model="model.s_origen" label="Utilizar Domicilio fiscal"></v-switch> -->
                                            <v-autocomplete v-model="model.origen" label="Ubicación Origen" return-object :items="origenes" :hide-no-data="true" item-text="descripcion" item-value="uuid" :rules="[rules.required]">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.identificador}} - {{ item.descripcion}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.identificador}} - {{ item.descripcion}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col sm="6" md="6" lg="6">

                                            <!-- <v-switch v-model="model.s_destino" label="Utilizar Domicilio Fiscal"></v-switch> -->
                                            <v-autocomplete v-model="model.destino" label="Ubicación Destino" return-object :items="destinos" :hide-no-data="true" item-text="descripcion" item-value="uuid" :rules="[rules.required]">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.identificador}} - {{ item.descripcion}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.identificador}} - {{ item.descripcion}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                    </v-row>
                                    <p />
                                    <v-row>

                                        <v-col sm="4" md="4" lg="4">
                                            <VueCtkDateTimePicker v-model="model.hora_salida" label="Fecha y Hora de Salida" locale="mx" button-now-translation="Hoy" format="YYYY-MM-DD HH:mm" :rules="[rules.required]" />

                                        </v-col>

                                        <v-col sm="4" md="4" lg="4">
                                            <VueCtkDateTimePicker v-model="model.hora_llegada" label="Fecha y Hora de Llegada" locale="mx" button-now-translation="Hoy" format="YYYY-MM-DD HH:mm" :rules="[rules.required]" />

                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field v-model="model.distancia" label="Kilometros Recorridos" :rules="[rules.required, rules.decimal]"></v-text-field>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2" v-if="model.transporte != null && model.transporte != ''">
                                            <v-text-field v-model="model.transporte.peso_bruto_vehicular" label="Peso Bruto Vehicular" :rules="[rules.required, rules.decimal]"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-autocomplete v-model="model.transporte" @change="cargaRelacionesfigura" label="Transporte" return-object :rules="[this.$rules.required]" :items="transportes" :hide-no-data="true" item-text="nombre" item-value="uuid">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.placa_vm}} - {{ item.nombre}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.placa_vm}} - {{ item.nombre}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-autocomplete v-model="model.figura" label="Figura Transporte" return-object :rules="[this.$rules.required]" :items="figuras" :hide-no-data="true" item-text="nombre" item-value="uuid">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.rfc}} - {{ item.nombre}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.rfc}} - {{ item.nombre}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-autocomplete clearable @change="model.remolque2=null" v-model="model.remolque1" return-object label="Remolque1" :items="remolques" :hide-no-data="true" item-text="placas" item-value="uuid">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.identificador}} - {{ item.placas}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.identificador}} - {{ item.placas}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-autocomplete clearable v-if="model.remolque1 != undefined && model.remolque1!=null" return-object v-model="model.remolque2" label="Remolque2" :items="remolques" :hide-no-data="true" item-text="placas" item-value="uuid">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{item.identificador}} - {{ item.placas}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{item.identificador}} - {{ item.placas}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <div v-if="model.TipoDeComprobante == 'I'">
                                        <h5><b>MERCANCIAS</b> </h5>
                                        <v-row>
                                            <v-col sm="6" md="6" lg="6">
                                                <v-autocomplete v-model="producto2" label="Producto" :items="mercancias" return-object :hide-no-data="true" item-text="nombre" item-value="clave">
                                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                                        <span class="pr-2">
                                                            {{item.clave}} - {{ item.nombre}}
                                                        </span>
                                                    </template>
                                                    <template v-slot:item="{ index, item }">
                                                        {{item.clave}} - {{ item.nombre}}
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col sm="2" md="2" lg="2">
                                                <v-text-field v-model="cantidad2" label="Cantidad"></v-text-field>
                                            </v-col>
                                            <v-col sm="2" md="2" lg="2">
                                                <v-text-field v-model="nota" label="Nota"></v-text-field>
                                            </v-col>

                                            <v-col sm="2" md="2" lg="2">
                                                <v-btn color="default" large @click="agregar_mercancias()" title="Agregar Mercancia" v-tippy>
                                                    <v-icon>mdi-plus-box</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-client-table ref="vuetable" :data="model.lista_mercancias" :columns="columns_mercancias" :options="options_mercancias" class="elevation-2 pa-2">

                                            <template slot="actions" slot-scope="props">
                                                <v-btn color="error" fab x-small title="Eliminar Registro" @click="eliminar_mercancia(props.row.producto)">
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-client-table>
                                    </div>
                                </v-card>
                                <p />
                                <v-row>
                                    <v-col sm="12" md="6" lg="6">
                                        <v-text-field v-model="model.observaciones" return-object label="Observaciones"></v-text-field>
                                    </v-col>
                                     <v-col sm="12" md="6" lg="6">
                                        <v-text-field v-model="model.relacionado" return-object label="04 - Sustitución de CFDI previo"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-card elevation="3" class="pa-5">
                                    <h5><b>CONCEPTOS</b> </h5>
                                    <v-row>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-autocomplete v-model="producto" label="Producto" @change="precio=producto.precio_venta; iva_traslado=producto.iva; no_identificacion=producto.clave;" :items="productos" return-object :hide-no-data="true" item-text="nombre" item-value="clave">
                                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                                    <span class="pr-2">
                                                        {{ item.nombre}}
                                                    </span>
                                                </template>
                                                <template v-slot:item="{ index, item }">
                                                    {{ item.nombre}}
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="1" md="1" lg="1">
                                            <v-text-field v-model="no_identificacion" class="text-center" label="No. Identificación"></v-text-field>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field v-model="cantidad" class="text-center" label="Cantidad"></v-text-field>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <v-text-field v-model="precio" label="Precio Unitario"></v-text-field>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <v-text-field v-model="descuento" label="$ Descuento"></v-text-field>
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1">
                                            <v-btn color="default" large @click="agregar_producto()" title="Agregar Concepto" v-tippy>
                                                <v-icon>mdi-plus-box</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <h5 style="color:green">IMPUESTOS </h5>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <v-text-field v-model="iva_traslado" label="% IVA Trasladado"></v-text-field>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <v-text-field v-model="iva_retenido" label="% IVA Retendido"></v-text-field>
                                        </v-col>
                                        <v-col v-if="model.TipoDeComprobante == 'I'" sm="2" md="2" lg="2">
                                            <v-text-field v-model="isr_retenido" label="% ISR Retenido"></v-text-field>
                                        </v-col>

                                    </v-row>
                                </v-card>
                                <p />
                                <v-client-table ref="vuetable" :data="model.lista_productos" :columns="model.TipoDeComprobante == 'I'?columns_productos:columns_mercancias_sincarta" :options="options_productos" class="elevation-3 pa-5">

                                    <template slot="actions" slot-scope="props">
                                        <v-btn color="error" fab x-small title="Eliminar Registro" @click="eliminar_producto(props.row.producto)">
                                            <v-icon>mdi-trash-can</v-icon>
                                        </v-btn>
                                    </template>

                                    <template slot="precio" slot-scope="props">
                                        <div class="text-right">$ {{props.row.precio}}</div>
                                    </template>
                                    <template slot="subtotal" slot-scope="props">
                                        <div class="text-right">$ {{props.row.subtotal}}</div>
                                    </template>
                                    <template slot="descuento" slot-scope="props">
                                        <div class="text-right">$ {{props.row.descuento}}</div>
                                    </template>
                                    <template slot="iva_traslado" slot-scope="props">
                                        <div class="text-right">$ {{props.row.iva_traslado}}</div>
                                    </template>
                                    <template slot="iva_retenido" slot-scope="props">
                                        <div class="text-right">$ {{(parseFloat(props.row.iva_retenido) + parseFloat(props.row.isr_retenido)).toFixed(2)}}</div>
                                    </template>
                                    <template slot="total" slot-scope="props">
                                        <div class="text-right">$ {{props.row.total}}</div>
                                    </template>

                                </v-client-table>
                                <p />
                                <div v-if="model.TipoDeComprobante == 'I'">
                                    <v-row>
                                        <v-spacer />
                                        <v-col class="text-right overline font-weight-bold" sm="2" md="2" lg="2">
                                            SUBTOTAL:
                                        </v-col>
                                        <v-col class=" text-right overline font-weight-bold" sm="1" md="1" lg="1">
                                            {{subtotal_factura}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-spacer />
                                        <v-col class="text-right overline font-weight-bold" sm="2" md="2" lg="2">
                                            DESCUENTO:
                                        </v-col>
                                        <v-col class=" text-right overline font-weight-bold" sm="1" md="1" lg="1">
                                            {{descuento_factura}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-spacer />
                                        <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                            IMPUESTOS TRASLADADOS:
                                        </v-col>
                                        <v-col class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                            {{imp_traslado_factura}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-spacer />
                                        <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                            IMPUESTOS RETENIDOS:
                                        </v-col>
                                        <v-col class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                            {{imp_retenido_factura}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-spacer />
                                        <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                            TOTAL:
                                        </v-col>
                                        <v-col class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                            {{total_factura}}
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="editando" color="default" large @click="cancelar()">
                            <v-icon>mdi-cancel</v-icon> Cancelar
                        </v-btn>
                        <v-btn color="secondary" large @click.native="guardar()">
                            <v-icon>mdi-content-save</v-icon> Guardar Borrador
                        </v-btn>
                        <v-btn color="success" large @click.native="timbrar()">
                            <v-icon>mdi-qrcode</v-icon> Generar CFDI
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
                <pre>
                {{timbre}}
                </pre>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
    name: "DashboardDataTables",

    data: () => ({
        series: [],
        url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
        nota: "",
        editando: false,
        menu1: false,
        model: {
            concarta: true,
            FechaPago: "",
            serie: "",
            folio: "",
            UsoCFDI: "G03",
            Moneda: "MXN",
            TipoDeComprobante: "T",
            LugarExpedicion: "06300",
            FormaPago: "01",
            TipoCambio: "1",
            MetodoPago: "PUE",
            hora_salida: "",
            hora_llegada: "",
            distancia: "",
            origen: "",
            destino: "",
            emisor: "",
            remolque1: "",
            remolque2: "",
            transporte: "",
            lista_productos: [],
            lista_mercancias: [],
            figura: "",
            receptor: {
                "registro_fiscal": ""
            },
            uuid_empresa: "",
            uuid_licencia: "",
            uuid: "",
            estatus: "",
            fecha: "",
            tipo: "",
            observaciones: "",
            substituto: "",
            IdCCP:"",
        },
        total_factura: "0.00",
        subtotal_factura: "0.00",
        imp_traslado_factura: "0.00",
        imp_retenido_factura: "0.00",

        isr_retenido: 0,
        descuento_factura: "0.00",
        iva_traslado: 0,
        iva_retenido: 0,
        descuento: 0,
        subtotal_producto: 0,
        total_producto: 0,
        producto: "",
        cantidad: 1,
        no_identificacion: "",
        producto2: "",
        cantidad2: 1,
        nota: "",
        precio: 0,
        UsosCFDI: [],
        FormasPago: [],
        MetodosPago: [],
        Monedas: [{
                clave: "MXN",
                nombre: "PESO MEXICANO"
            },
            {
                clave: "USD",
                nombre: "DOLAR ESTADOUNIDENCE"
            },
            {
                clave: "EUR",
                nombre: "EURO"
            }
        ],
        TiposDeComprobante: [{
                clave: "T",
                nombre: "TRASLADO"
            },
            {
                clave: "I",
                nombre: "INGRESO"
            },
        ],
        timbre: "",
        tabla: "carta_porte",
        uuid_editando: "",
        con_mercancias: false,
        origenes: [],
        destinos: [],
        receptores: [],
        remolques: [],
        figuras: [],
        transportes: [],
        productos: [],
        mercancias: [],
        modal: false,
        usuario: "",
        clientes: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "CFDI",
                disabled: true,
                href: "",
            },
        ],
        rules: {},
        columns_productos: ["producto.nombre", "no_identificacion", "cantidad", "precio", "subtotal", "descuento", "iva_traslado", "iva_retenido", "total", "actions"],
        options_productos: {
            filterable: false,
            headings: {

                'producto.nombre': "Producto",
                "no_identificacion": "No. Identificación",
                catidad: "Cantidad",
                'precio': "Precio",
                "subtotal": "Subtotal",
                "descuento": "Descuento",
                "iva_traslado": "Trasladado",
                "iva_retenido": "Retenido",
                "total": "Total",
                actions: "Operaciones"
            }
        },
        columns_mercancias: ["producto.nombre", "cantidad", "nota", "actions"],
        options_mercancias: {
            filterable: false,
            headings: {
                'producto.nombre': "Mercancia",
                catidad: "Cantidad",
                nota: "Nota",
                actions: "Operaciones"
            }
        },
        columns_mercancias_sincarta: ["producto.nombre", "cantidad", "actions"],
        options_mercancias_sincarta: {
            filterable: false,
            headings: {
                'producto.nombre': "Producto",
                catidad: "Cantidad",
                actions: "Operaciones"
            }
        },
        items: [],
    }),
    computed: {
        nombre() {
            let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
            return nombre_usuario;
        }
    },
    methods: {
        validaRemolque: function () {
            try {
                if (this.model.remolque1 != undefined && this.model.remolque1 != null && this.model.remolque1 != "")
                    if (this.model.remolque1 == this.model.remolque2)
                        return "Remolque se encuentra duplicado";

                return true;
            } catch (error) {
                return true;
            }
        },
        getIndex: function (item) {
            const search = (element) => element.producto.uuid == item.uuid;
            var idx = this.model.lista_productos.findIndex(search);
            return idx;
        },
        getIndexMercancia: function (item) {
            const search = (element) => element.producto.uuid == item.uuid;
            var idx = this.model.lista_mercancias.findIndex(search);
            return idx;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        cargarCatalogosSAT: async function () {
            var self = this;

            await this.$axios.post(this.URL_SAT + "list_usos_cfdi/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.UsosCFDI = res.data;
                    }
                });

            await this.$axios.post(this.URL_SAT + "list_formas_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.FormasPago = res.data.sort(function (a, b) {
                            if (parseInt(a.clave) > parseInt(b.clave))
                                return 1;
                            if (parseInt(a.clave) < parseInt(b.clave))
                                return -1;
                            return 0;
                        });
                    }
                });

            await this.$axios.post(this.URL_SAT + "list_metodos_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.MetodosPago = res.data;
                    }
                });

        },
        cargar: async function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "filtros": {
                    "uuid": id
                }
            };
            await axios.post(this.$hostname + 'carta_porte/list_pre_carta_porte/', data)
                .then(async (res) => {

                    if (res.data != 'undefined') {

                        self.model = res.data.results[0];
                        if (self.model.concarta == true)
                            await self.cargarDestinos();

                        await self.calcular_totales();
                        await self.cargarProductos();
                        self.$root.$dialogLoader.hide();
                    }

                });

        },
        calcular_totales: function () {
            let self = this;
            self.total_factura = 0;
            self.subtotal_factura = 0;
            self.imp_retenido_factura = 0;
            self.imp_traslado_factura = 0;
            self.descuento_factura = 0;
            self.model.lista_productos.forEach(function (e) {
                self.total_factura += parseFloat(e.total);
                self.subtotal_factura += parseFloat(e.subtotal);
                self.imp_retenido_factura += parseFloat(e.iva_retenido) + parseFloat(e.isr_retenido);
                self.imp_traslado_factura += parseFloat(e.iva_traslado);
                self.descuento_factura += parseFloat(e.descuento);
            });
            self.total_factura = self.total_factura.toFixed(2);
            self.subtotal_factura = self.subtotal_factura.toFixed(2);
            self.imp_retenido_factura = self.imp_retenido_factura.toFixed(2);
            self.imp_traslado_factura = self.imp_traslado_factura.toFixed(2);
            self.descuento_factura = self.descuento_factura.toFixed(2);
        },
        cargarOrigenes: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            await axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.origenes = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarDestinos: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            await axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.destinos = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarEmisor: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                filtros: {
                    "uuid": this.model.uuid_empresa
                }
            };
            await axios.post(self.URL_ADM + 'list_empresas/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.model.emisor = res.data[0];

                        if (res.data[0].catalogo_series != undefined && res.data[0].catalogo_series.length > 0) {
                            res.data[0].catalogo_series.forEach(function (x) {
                                self.series.push({
                                    "id": x.serie,
                                    "text": x.serie
                                });
                            });
                        }

                        self.model.LugarExpedicion = self.model.emisor.domicilio.codigo_postal;
                        self.cargarOrigenes();
                        self.cargarDestinos();

                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarReceptores: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            await axios.post(self.URL + 'list_clientes/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.receptores = res.data;
                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarFiguras: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "activo": "Activo"
            };
            await axios.post(self.URL + 'list_figuras_transporte/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.figuras = res.data;
                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarTransportes: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "activo": "Activo"
            };
            await axios.post(self.URL + 'list_transporte/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.transportes = res.data;
                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargaRelacionesfigura: function () {
            if (this.model.transporte.uuid_figura_transporte != undefined) {
                const search = (element) => element.uuid == this.model.transporte.uuid_figura_transporte;
                var idx = this.figuras.findIndex(search);
                this.model.figura = this.figuras[idx];
            } else
                this.model.figura = null;

            if (this.model.transporte.uuid_remolque1 != undefined) {
                const search = (element) => element.uuid == this.model.transporte.uuid_remolque1;
                var idx = this.remolques.findIndex(search);
                this.model.remolque1 = this.remolques[idx];
            } else
                this.model.remolque1 = null;

            if (this.model.transporte.uuid_remolque2 != undefined) {
                const search = (element) => element.uuid == this.model.transporte.uuid_remolque2;
                var idx = this.remolques.findIndex(search);
                this.model.remolque2 = this.remolques[idx];
            } else
                this.model.remolque2 = null;
        },
        cargarRemolques: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa
            };
            await axios.post(self.URL + 'list_remolque/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.remolques = res.data;
                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarProductos: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "activo": "Activo"
            };
            await axios.post(self.URL + 'list_producto/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        if (self.model.TipoDeComprobante == 'T') {
                            self.productos = res.data.filter(i => i.tipo_producto == "Mercancia");
                            self.mercancias = self.productos;
                            self.producto = null;
                            self.cantidad = 1;
                            self.iva_traslado = 0;
                            self.iva_retenido = 0;
                            self.isr_retenido = 0;
                            self.precio = 0;
                            self.no_identificacion = "",
                                self.Descuento = 0;
                            //   self.model.concarta = true;
                        } else {
                            self.productos = res.data.filter(i => i.tipo_producto == "Concepto");
                            self.producto = null;
                            self.cantidad = 1;
                            self.iva_traslado = 0;
                            self.iva_retenido = 0;
                            self.isr_retenido = 0;
                            self.precio = 0;
                            self.no_identificacion = "",
                                self.Descuento = 0;
                            //    self.model.lista_productos = [];
                        }
                    }
                    self.$root.$dialogLoader.hide();
                });
        },

        agregar_producto: function () {
            let self = this;
            if (this.producto == null) {
                self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Debe especificar el producto",
                    footer: "",
                });
                return false;
            }
            if (parseFloat(this.cantidad) == 0 || this.cantidad == null || this.cantidad == "") {
                self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Debe especificar la cantidad",
                    footer: "",
                });
                return false;
            }

            let _descuento = parseFloat(this.descuento).toFixed(2);

            let _importe = ((parseFloat(this.cantidad) * parseFloat(this.precio))).toFixed(2);

            let _base_gravable = (parseFloat(_importe) - parseFloat(this.descuento)).toFixed(2);

            let _iva_traslado = 0;
            let _iva_tasa_traslado = 0;
            if (parseFloat(this.iva_traslado) > 0) {
                _iva_traslado = (parseFloat(_base_gravable) * (parseFloat(this.iva_traslado) / 100)).toFixed(2);
                _iva_tasa_traslado = (parseFloat(this.iva_traslado) / 100).toFixed(6);
            }

            let _iva_retenido = 0;
            let _iva_tasa_retenido = 0;
            if (parseFloat(this.iva_retenido) > 0) {
                _iva_retenido = (parseFloat(_base_gravable) * (parseFloat(this.iva_retenido) / 100)).toFixed(2);
                _iva_tasa_retenido = (parseFloat(this.iva_retenido) / 100).toFixed(6);
            }

            let _isr_retenido = 0;
            let _isr_tasa_retenido = 0;
            if (parseFloat(this.isr_retenido) > 0) {
                _isr_retenido = (parseFloat(_base_gravable) * (parseFloat(this.isr_retenido) / 100)).toFixed(2);
                _isr_tasa_retenido = (parseFloat(this.isr_retenido) / 100).toFixed(6);
            }

            let _total = (parseFloat(_importe) - parseFloat(_descuento) + parseFloat(_iva_traslado) - parseFloat(_iva_retenido) - parseFloat(_isr_retenido)).toFixed(2);

            this.model.lista_productos.push({
                "producto": this.producto,
                "no_identificacion": this.no_identificacion,
                "cantidad": parseFloat(this.cantidad),
                "precio": parseFloat(this.precio),
                "subtotal": _importe,
                "iva_traslado": _iva_traslado,
                "iva_retenido": _iva_retenido,
                "total": _total,
                "iva_tasa_retenido": _iva_tasa_retenido,
                "iva_tasa_traslado": _iva_tasa_traslado,
                "isr_retenido": _isr_retenido,
                "isr_tasa_retenido": _isr_tasa_retenido,
                "descuento": _descuento,
                "base_grabable": _base_gravable
            })

            this.producto = null;
            this.cantidad = 1;
            this.iva_traslado = 0;
            this.iva_retenido = 0;
            this.isr_retenido = 0;
            this.precio = 0;
            this.no_identificacion = "",
                this.Descuento = 0;

            this.calcular_totales();

        },
        agregar_mercancias: function () {
            let self = this;

            if (this.producto2 == null) {
                self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Debe especificar el producto",
                    footer: "",
                });
                return false;
            }
            if (parseFloat(this.cantidad2) == 0 || this.cantidad2 == "" || this.cantidad2 == null) {
                self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Debe especificar la cantidad",
                    footer: "",
                });
                return false;
            }

            this.model.lista_mercancias.push({
                "producto": this.producto2,
                "cantidad": parseFloat(this.cantidad2),
                "nota": this.nota
            })

            this.producto2 = null;
            this.cantidad2 = null;

        },
        eliminar_mercancia: function (item) {
            var self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var idx = this.getIndexMercancia(item);
            this.model.lista_mercancias.splice(idx, 1);
            this.$root.$dialogLoader.hide();
        },
        eliminar_producto: function (item) {
            var self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var idx = this.getIndex(item);
            this.model.lista_productos.splice(idx, 1);
            this.calcular_totales();
            this.$root.$dialogLoader.hide();
        },
        validar: function () {
            var self = this;
            if (this.$refs.form.validate()) {

                if (self.model.TipoDeComprobante == 'T' && self.model.concarta == false && self.model.receptor.registro_fiscal == "") {
                    self.$swal({
                        type: "error",
                        title: "Datos Incompletos",
                        text: "Debe especificar el Receptor",
                        footer: "",
                    });
                    return false;
                }
                if (self.model.TipoDeComprobante == 'I' &&  self.model.receptor.registro_fiscal == "") {
                    self.$swal({
                        type: "error",
                        title: "Datos Incompletos",
                        text: "Debe especificar el Receptor",
                        footer: "",
                    });
                    return false;
                }
                if (self.model.concarta == true) {
                    if (self.model.hora_salida == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Salida",
                            footer: "",
                        });
                        return false;
                    }
                    if (self.model.hora_llegada == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Llegada",
                            footer: "",
                        });
                        return false;
                    }
                    const hs = new Date(self.model.hora_salida);
                    const he = new Date(self.model.hora_llegada);

                    if (hs > he) {
                        self.$swal({
                            type: "error",
                            title: "Datos Incorrectos",
                            text: "La Fecha y Hora de Salida no puede ser mayor a la de entrada",
                            footer: "",
                        });
                        return false;
                    }
                }
                if (self.model.lista_productos.length == 0) {
                    self.$swal({
                        type: "error",
                        title: "Datos Incompletos",
                        text: "Debe especificar al menos un concepto",
                        footer: "",
                    });
                    return false;
                }
                if (self.model.TipoDeComprobante == 'I' && self.model.lista_mercancias.length == 0 && self.model.concarta == true) {
                    self.$swal({
                        type: "error",
                        title: "Datos Incompletos",
                        text: "Debe especificar al menos una mercancia",
                        footer: "",
                    });
                    return false;
                }

                return true;

            } else {
                self.$swal({
                    type: "error",
                    title: "Datos Incompletos",
                    text: "Verifique la informacón y vuelva a intentarlo",
                    footer: "",
                });
                return false;
            }

        },
        enviarTimbrar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            self.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "rfc": self.model.emisor.rfc,
                "json": self.timbre,
                "usuario":self.nombre
            };
            axios.post(self.url + 'carta_porte/guardar_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se envio correctamente. ",
                            footer: "No. de Solicitud: " + res.data.id_solicitud,
                        });
                        self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(res.data.id_solicitud));
                        self.$router.replace("/cartaporte");
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    self.$root.$dialogLoader.hide();
                });

        },

        guardar: function (item) {
            var self = this;

            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                let uuid = self.$uuid.v4();
                let metodo = "save_pre_carta_porte/";

                if (self.model.TipoDeComprobante == 'T' && self.model.concarta == true) {
                    self.model.lista_mercancias = [];
                    self.model.Moneda = "MXN";
                    self.model.FormaPago = "01";
                    self.model.TipoCambio = "1";
                    self.model.MetodoPago = "PUE";
                    self.model.receptor = self.model.emisor;
                }
                let data = self.model;

                data.uuid = uuid;
                data.estatus = 0;
                data.fecha = this.model.FechaPago + 'T00:00:00',
                    data.tipo = "Web";
                let param = {
                    "datos": data
                }
                if (this.editando) {
                    uuid = this.uuid_editando;
                    data.uuid = uuid;
                    metodo = "update_pre_carta_porte/";
                    param = data;
                }

                this.$axios.post(this.$hostname + "carta_porte/" + metodo, param)
                    .then(res => {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente.",
                            footer: "",
                        });
                        self.$root.$dialogLoader.hide();
                        return true;

                    });
            } else {
                return false;
            }
        },
        cancelar: function () {

            this.$router.replace("/pre_carta_porte");
        },
        timbrar: function () {

            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");

                var self = this;
                let totalKG = 0;
                let unidad = "";
                let conceptos_traslado = [];
                let mercancias_complemento = [];
                let concepto = "";
                let tasa = "";
                let tasa_r = "";
                let totaltraslado = 0;
                let subtotal = 0;
                let total_isr_retenido = 0;
                let total_iva_retenido = 0;
                let hidro = "";

                let base = 0;
                /*      if (self.model.TipoDeComprobante == 'T') {
                         self.model.Moneda = "MXN";
                          self.model.receptor.registro_fiscal = self.model.emisor;
                          self.model.receptor.domicilio = self.model.emisor.domicilio;

                     } */
                if (self.model.TipoDeComprobante == 'T' && self.model.concarta == true) {
                    self.model.lista_mercancias = [];
                    self.model.Moneda = "MXN";
                    self.model.FormaPago = "01";
                    self.model.TipoCambio = "1";
                    self.model.MetodoPago = "PUE";
                    self.model.receptor = self.model.emisor;
                }
                self.model.lista_productos.forEach(function (elemento) {
                    concepto = {
                        "Cantidad": elemento.cantidad.toString(),
                        "ClaveProdServ": elemento.producto.clave_sat,
                        "ObjetoImp": elemento.producto.objetoImp,
                        "ClaveUnidad": elemento.producto.unidad_sat,
                        "Descripcion": elemento.producto.nombre,
                        "Importe": elemento.subtotal.toString(),
                        "ValorUnitario": elemento.precio.toString(),
                        "Descuento": elemento.descuento.toString(),
                        "NoIdentificacion": elemento.no_identificacion
                    }
                    if (elemento.producto.hidrocarburos == "Sí") {
                        hidro =  {
                                "HidroYPetro":{
                                              "Version":"1.0",
                                              "TipoPermiso": elemento.producto.tipo_permiso,
                                              "NumeroPermiso": elemento.producto.numero_permiso,
                                              "ClaveHYP": elemento.producto.clave_sat,
                                              "SubProductoHYP": elemento.producto.sub_producto_hyp
                                            }
                              }

                          concepto.ComplementoConcepto = hidro;

                    }


                    if (self.model.TipoDeComprobante == 'I') {
                        concepto.Impuestos = {
                            "Traslados": [],
                            "Retenciones": []
                        }
                        if (parseFloat(elemento.iva_traslado) > 0) {
                            concepto.Impuestos.Traslados.push({
                                "Impuesto": "002",
                                "TipoFactor": "Tasa",
                                "TasaOCuota": elemento.iva_tasa_traslado.toString(),
                                "Base": elemento.base_grabable.toString(),
                                "Importe": elemento.iva_traslado.toString()
                            });
                        }

                        if (parseFloat(elemento.iva_retenido) > 0) {
                            concepto.Impuestos.Retenciones.push({
                                "Impuesto": "002",
                                "TipoFactor": "Tasa",
                                "TasaOCuota": elemento.iva_tasa_retenido.toString(),
                                "Base": elemento.base_grabable.toString(),
                                "Importe": elemento.iva_retenido.toString()
                            });
                            total_iva_retenido += parseFloat(elemento.iva_retenido);

                        }

                        if (parseFloat(elemento.isr_retenido) > 0) {
                            concepto.Impuestos.Retenciones.push({
                                "Impuesto": "001",
                                "TipoFactor": "Tasa",
                                "TasaOCuota": elemento.isr_tasa_retenido.toString(),
                                "Base": elemento.base_grabable.toString(),
                                "Importe": elemento.isr_retenido.toString()
                            });
                            total_isr_retenido += parseFloat(elemento.isr_retenido);

                        }
                        if (parseFloat(elemento.isr_retenido) > 0 || parseFloat(elemento.iva_retenido) > 0 || parseFloat(elemento.iva_traslado) > 0) {
                            base += parseFloat(elemento.base_grabable);
                        }

                        tasa = elemento.iva_tasa_traslado;

                        if (concepto.Impuestos["Traslados"].length == 0)
                            delete concepto.Impuestos["Traslados"];

                        if (concepto.Impuestos["Retenciones"].length == 0)
                            delete concepto.Impuestos["Retenciones"];

                    } else {
                        delete concepto["Descuento"];
                        if (self.model.concarta == true) {
                            mercancias_complemento.push({
                                "BienesTransp": elemento.producto.clave_sat,
                                "Cantidad": elemento.cantidad.toString(),
                                "ClaveUnidad": elemento.producto.unidad_sat,
                                "Descripcion": elemento.producto.nombre,
                                "Dimensiones": "",
                                "MaterialPeligroso": elemento.producto.material_peligroso,
                                "CveMaterialPeligroso": elemento.producto.clave_material_peligroso,
                                "Embalaje": elemento.producto.embalaje,
                                "PesoEnKg": elemento.producto.pesokg.toString(),
                                "Unidad": elemento.producto.unidad_sat,
                                "Nota": ""
                            });
                        }
                        totalKG = parseFloat(totalKG) + parseFloat(elemento.producto.pesokg);
                        unidad = elemento.producto.unidad_sat;

                    };
                    conceptos_traslado.push(concepto);
                });
                if (self.model.TipoDeComprobante == 'I' && self.model.concarta) {
                    self.model.lista_mercancias.forEach(function (elemento) {
                        mercancias_complemento.push({
                            "BienesTransp": elemento.producto.clave_sat,
                            "Cantidad": elemento.cantidad.toString(),
                            "ClaveUnidad": elemento.producto.unidad_sat,
                            "Descripcion": elemento.producto.nombre,
                            "Dimensiones": "",
                            "MaterialPeligroso": elemento.producto.material_peligroso,
                            "CveMaterialPeligroso": elemento.producto.clave_material_peligroso,
                            "Embalaje": elemento.producto.embalaje,
                            "PesoEnKg": elemento.producto.pesokg,
                            "Unidad": elemento.producto.unidad_sat,
                            "Nota": elemento.nota.toString()

                        });
                        totalKG = parseFloat(totalKG) + parseFloat(elemento.producto.pesokg);
                        unidad = elemento.producto.unidad_sat;
                    });
                }

                mercancias_complemento.forEach(merc => {
                    merc['CantidadTransporta'] = [{
                        "Cantidad": merc['Cantidad'],
                        "IDOrigen": 'OR' + self.model.origen.identificador,
                        "IDDestino": 'DE' + self.model.destino.identificador
                    }]
                });

                let impuestos = {
                    "Traslados": [{
                        "Impuesto": "002",
                        "TipoFactor": "Tasa",
                        "TasaOCuota": tasa.toString(),
                        "Importe": self.imp_traslado_factura.toString(),
                        "Base": base.toString(),
                    }],
                    "Retenciones": [],
                    "TotalImpuestosRetenidos": self.imp_retenido_factura.toString(),
                    "TotalImpuestosTrasladados": self.imp_traslado_factura.toString()
                };
                if (parseFloat(total_isr_retenido) > 0) {
                    impuestos.Retenciones.push({
                        "Impuesto": "001",
                        "Importe": total_isr_retenido.toString()
                    });
                };
                if (parseFloat(total_iva_retenido) > 0) {
                    impuestos.Retenciones.push({
                        "Impuesto": "002",
                        "Importe": total_iva_retenido.toString()
                    });
                };
                if (parseFloat(self.imp_retenido_factura) == 0)
                    delete impuestos["Retenciones"];

                if (parseFloat(self.imp_traslado_factura) == 0)
                    delete impuestos["Traslados"];

                let complemento = {};
                if (self.model.concarta)
                    complemento = {
                        "Version": "3.1",
                        "IdCCP": self.model.IdCCP,
                        "Ubicaciones": [{
                                "Domicilio": {
                                    "Calle": self.model.origen.domicilio.calle,
                                    "CodigoPostal": self.model.origen.domicilio.codigo_postal,
                                    "Colonia": self.model.origen.domicilio.colonia,
                                    "Estado": self.model.origen.domicilio.estado,
                                    "Localidad": self.model.origen.domicilio.localidad,
                                    "Municipio": self.model.origen.domicilio.municipio,
                                    "NumeroExterior": self.model.origen.domicilio.numero_ext,
                                    "Pais": self.model.origen.domicilio.pais,
                                    "Referencia": ""
                                },
                                "FechaHoraSalidaLlegada": self.model.hora_salida.replace(' ', 'T') + ':00',
                                "IDUbicacion": 'OR' + self.model.origen.identificador,
                                "NombreRemitenteDestinatario": self.model.origen.descripcion,
                                "RFCRemitenteDestinatario": self.model.origen.rfc, //self.model.receptor.registro_fiscal.rfc, // self.model.emisor.rfc,
                                "TipoUbicacion": "Origen"
                            },
                            {
                                "Domicilio": {
                                    "Calle": self.model.destino.domicilio.calle,
                                    "CodigoPostal": self.model.destino.domicilio.codigo_postal,
                                    "Colonia": self.model.destino.domicilio.colonia,
                                    "Estado": self.model.destino.domicilio.estado,
                                    "Localidad": self.model.destino.domicilio.localidad,
                                    "Municipio": self.model.destino.domicilio.municipio,
                                    "NumeroExterior": self.model.destino.domicilio.numero_ext,
                                    "Pais": self.model.destino.domicilio.pais,
                                    "Referencia": ""
                                },
                                "FechaHoraSalidaLlegada": self.model.hora_llegada.replace(' ', 'T') + ':00',
                                "IDUbicacion": 'DE' + self.model.destino.identificador,
                                "NombreRemitenteDestinatario": self.model.destino.descripcion,
                                "NumRegIdTrib": "",
                                "RFCRemitenteDestinatario": self.model.destino.rfc,
                                "ResidenciaFiscal": "",
                                "TipoUbicacion": "Destino",
                                "DistanciaRecorrida": self.model.distancia
                            }
                        ],
                        "Mercancias": {
                            "Autotransporte": {
                                "IdentificacionVehicular": {
                                    "AnioModeloVM": self.model.transporte.anio_modelo_vm,
                                    "ConfigVehicular": self.model.transporte.config_vehicular,
                                    "PlacaVM": self.model.transporte.placa_vm,
                                    "PesoBrutoVehicular": self.model.transporte.peso_bruto_vehicular
                                },
                                "NumPermisoSCT": self.model.transporte.no_permiso_sct,
                                "PermSCT": self.model.transporte.permiso_sct,
                                "Seguros": {
                                    "AseguraCarga": self.model.transporte.asegura_carga,
                                    "AseguraRespCivil": self.model.transporte.asegura_resp_civil,
                                    "PolizaCarga": self.model.transporte.poliza_carga,
                                    "PolizaRespCivil": self.model.transporte.poliza_resp_civil,
                                    "PrimaSeguro": "",
                                    "AseguraMedAmbiente": self.model.transporte.asegura_med_ambiente,
                                    "PolizaMedAmbiente": self.model.transporte.poliza_med_ambiente
                                }
                            },
                            "Mercancia": mercancias_complemento,
                            "NumTotalMercancias": mercancias_complemento.length.toString(),
                            "PesoBrutoTotal": totalKG.toString(),
                            "PesoNetoTotal": totalKG.toString(),
                            "UnidadPeso": unidad
                        },
                        "TotalDistRec": self.model.distancia,
                        "TranspInternac": "No",
                        "FiguraTransporte": [{
                            "NombreFigura": self.model.figura.nombre,
                            "NumLicencia": self.model.figura.no_licencia,
                            "RFCFigura": self.model.figura.rfc,
                            "TipoFigura": self.model.figura.clave_figura
                        }]

                    };
                if (self.model.concarta && self.model.remolque1 != undefined && self.model.remolque1 != null) {
                    complemento.Mercancias.Autotransporte.Remolques = [];
                    complemento.Mercancias.Autotransporte.Remolques.push({
                        "Placa": self.model.remolque1.placas,
                        "SubTipoRem": self.model.remolque1.clave_remolque
                    });
                }
                if (self.model.concarta && self.model.remolque2 != undefined && self.model.remolque2 != null) {
                    complemento.Mercancias.Autotransporte.Remolques.push({
                        "Placa": self.model.remolque2.placas,
                        "SubTipoRem": self.model.remolque2.clave_remolque
                    });
                }


                let lugar = self.model.LugarExpedicion;
                if( self.model.receptor.rfc != 'XAXX010101000' ){
                        lugar =  self.model.receptor.domicilio.codigo_postal;
                }

                self.timbre = {
                    "Version": "4.0",
                    "SubTotal": "0",
                    "Total": "0",
                    "Serie": "",
                    "Folio": "",
                    "Exportacion": "01",
                    "NoCertificado": "",
                    "Fecha": this.model.FechaPago + 'T00:00:00',
                    "Moneda": self.model.Moneda,
                    "TipoDeComprobante": self.model.TipoDeComprobante,
                    "LugarExpedicion": self.model.LugarExpedicion,
                     "CfdiRelacionados": [
                        {
                            "TipoRelacion": "04",
                            "UUIDS": [
                                self.model.relacionado
                            ]
                        }
                    ],
                    "Emisor": {
                        "Nombre": self.model.emisor.razon_social,
                        "RegimenFiscal": self.model.emisor.regimen,
                        "Rfc": self.model.emisor.rfc,
                        "Domicilio": {
                            "Calle": self.model.emisor.domicilio.calle,
                            "CodigoPostal": self.model.emisor.domicilio.codigo_postal,
                            "Colonia": self.model.emisor.domicilio.colonia,
                            "Estado": self.model.emisor.domicilio.estado,
                            "Localidad": self.model.emisor.domicilio.localidad,
                            "Municipio": self.model.emisor.domicilio.municipio,
                            "NumeroExterior": self.model.emisor.domicilio.numero_ext,
                            "Pais": self.model.emisor.domicilio.pais,
                            "Referencia": ""
                        },
                    },
                    "Receptor": {
                        "Rfc": self.model.receptor.rfc,
                        "Nombre": self.model.receptor.razon_social,
                        "UsoCFDI": self.model.UsoCFDI,
                        "RegimenFiscalReceptor": self.model.receptor.regimen_fiscal_receptor,
                        "DomicilioFiscalReceptor": lugar,
                        "Domicilio": {
                            "Calle": self.model.receptor.domicilio.calle,
                            "CodigoPostal": self.model.receptor.domicilio.codigo_postal,
                            "Colonia": self.model.receptor.domicilio.colonia,
                            "Estado": self.model.receptor.domicilio.estado,
                            "Localidad": self.model.receptor.domicilio.localidad,
                            "Municipio": self.model.receptor.domicilio.municipio,
                            "NumeroExterior": self.model.receptor.domicilio.numero_ext,
                            "Pais": self.model.receptor.domicilio.pais,
                            "Referencia": ""
                        },
                        "Email": self.model.receptor.email
                    },
                    "Conceptos": conceptos_traslado,
                    "Impuestos": null,
                    "Complemento": {
                        "CartaPorte": complemento
                    },
                    "Observaciones": self.model.observaciones

                };
                if (parseInt(self.model.folio) > 0) {
                    self.timbre.Folio = self.model.folio;
                }
                self.timbre.Serie = self.model.serie;
                if (self.model.TipoDeComprobante == 'I') {
                    self.timbre.FormaPago = self.model.FormaPago;
                    self.timbre.TipoCambio = self.model.TipoCambio;
                    self.timbre.MetodoPago = self.model.MetodoPago;
                    self.timbre.Impuestos = impuestos;
                    self.timbre.Descuento = self.descuento_factura.toString();
                    self.timbre.SubTotal = self.subtotal_factura.toString();
                    self.timbre.Total = self.total_factura.toString();
                }

                if (self.model.TipoDeComprobante == 'T') {
                    //   self.timbre.lista_mercancias = [];
                    if (self.model.concarta == true) {
                        self.timbre.Receptor = self.timbre.Emisor;
                        self.timbre.Receptor.RegimenFiscalReceptor = self.model.emisor.regimen;
                        self.timbre.Receptor.DomicilioFiscalReceptor = self.model.emisor.domicilio.codigo_postal;
                    }
                    self.timbre.Moneda = "XXX";
                    self.timbre.Receptor.UsoCFDI = 'S01';
                    delete self.timbre["MetodoPago"];
                    delete self.timbre["FormaPago"];
                    delete self.timbre["TipoCambio"];
                    delete self.timbre["Descuento"];

                }
                if (self.model.concarta == false) {
                    delete self.timbre["Complemento"];
                }
                if(self.model.relacionado == "" || self.model.relacionado == null){
                  delete self.timbre["CfdiRelacionados"];
                }
                this.$root.$dialogLoader.hide();
                this.enviarTimbrar();

            }
        },

    },
    created: async function () {
        this.rules = this.$rules;
        this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
        this.model.uuid_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));

        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_ADM = this.$hostname + "carta_porte/administracion/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";

        await this.cargarEmisor();
        await this.cargarReceptores();
        await this.cargarFiguras();
        await this.cargarTransportes();
        await this.cargarRemolques();
        await this.cargarProductos();
        await this.cargarCatalogosSAT();
        this.model.FechaPago = moment().format("YYYY-MM-DD");
        this.model.IdCCP = "CCC" + this.$uuid.v4().toString().toUpperCase().substr(3)

    },
    async mounted() {
        this.uuid_editando = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_carta_porte")));
        this.editando = this.uuid_editando != '';
        if (this.editando) {
            this.$local_storage.set(this.$crypto.SHA256("uuid_carta_porte"), this.$crypto.encrypted(''));
            await this.cargar(this.uuid_editando);
        }
    },
};
</script>
